export default __webpack_public_path__ + "static/media/cat1.d0be8574.jpg";